import { faker } from '@faker-js/faker'

import { getDescriptionTemplate } from './DescriptionTemplate'
import { getServiceOfferOption } from './ServiceOfferOption'

import { ExtraCostStatus, ServiceOffer, TargetGender, TargetLanguage } from '../../contracts/service-offer'
import { ExtraPriceChargeType, ExtraPriceType } from '../../contracts/service-offer/AdminServiceOfferExtraPrice'
import { OperationType } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getServiceOffer = asBuilder((): ServiceOffer => {
  return {
    title: faker.string.uuid(),
    treatments: faker.helpers.multiple(() => ({
      id: faker.number.int(),
      name: faker.string.uuid(),
    })),
    freeTags: faker.helpers.multiple(() => faker.string.uuid()),
    targetLanguage: faker.helpers.enumValue(TargetLanguage),
    targetGender: faker.helpers.enumValue(TargetGender),
    period: {
      startsAt: '2021-01-01T00:00:00',
      endsAt: '2099-01-01T00:00:00',
    },
    paymentEnabled: faker.datatype.boolean(),
    exclusivePrice: faker.datatype.boolean(),
    vat: faker.helpers.enumValue(ExtraCostStatus),
    extraPrices: faker.helpers.multiple(
      () => ({
        name: faker.lorem.word(),
        type: faker.helpers.enumValue(ExtraPriceType),
        chargeType: faker.helpers.enumValue(ExtraPriceChargeType),
        amount: faker.number.int({ min: 1, max: 1000000 }),
      }),
      {
        count: {
          min: 1,
          max: 10,
        },
      },
    ),
    options: faker.helpers.multiple(getServiceOfferOption),
    thumbnail: { url: faker.image.url() },
    cardImage: { url: faker.image.url() },
    marketingImage: { url: faker.image.url() },
    descriptionImages: { images: faker.helpers.multiple(() => ({ url: faker.image.url() })) },
    description: faker.lorem.sentence(),
    descriptionTemplate: getDescriptionTemplate(),
    operationType: faker.helpers.enumValue(OperationType),
  }
})
